import axios from "axios";
import  API_URL from "./apiRest"

import Auth from "auth/Auth";
import store from "store";
import { showWarningMessage } from "reducers/application/applicationActions";

const requestInterceptor = (config) => ({
    ...config,
    headers: {
        ...config.headers,
        'authorization': localStorage.getItem('access_token'),
    },
});

class HttpClient {

    constructor(loggedIn) {
        const options = { baseURL: API_URL };
        const instance = axios.create(options);
        if (loggedIn) {
            instance.interceptors.request.use(requestInterceptor);
            instance.interceptors.response.use(function (response) {                
                return response;
            }, function (error) {                
                if (error.response  && error.response.status === 401) {
                    new Auth().logout();
                    store.dispatch(showWarningMessage("Acceso no autorizado."));
                } else {
                    return Promise.reject(error);
                }
            });
        }
        return instance;
    }

}

export default HttpClient;


// WEBPACK FOOTER //
// ./src/utils/HttpClient/HttpClient.js